/* eslint-disable import/prefer-default-export */
export const NET_BANKING_OPTIONS = [
  { label: 'Bank of India', value: '240' },
  { label: 'Indian Bank', value: '490' },
  { label: 'Tamilnad Mercantile Bank', value: '620' },
  { label: 'Central Bank of India', value: '740' },
  { label: 'Bank of Maharashtra', value: '750' },
  { label: 'Karur Vysya Bank', value: '760' },
  { label: 'Canara Bank', value: '930' },
  { label: 'Punjab National Bank', value: '1220' },
  { label: 'RBL Bank Limited', value: '1500' },
  { label: 'SVC Cooperative Bank Ltd', value: '1700' },
  { label: 'Uco Bank', value: '2030' },
  { label: 'Punjab and Sind Bank', value: '2390' },
  { label: 'Standard Chartered Bank', value: '450' },
  { label: 'Indian Overseas NetBanking', value: '420' },
  { label: 'Dhanlaxmi Bank', value: '370' },
  { label: 'Jammu and Kashmir Bank', value: '350' },
  { label: 'Bank of Baroda Retail', value: '310' },
  { label: 'Union Bank of India', value: '190' },
  { label: 'South Indian Bank', value: '180' },
  { label: 'Karnataka Bank', value: '140' },
  { label: 'JUSPAY VISA ALTID TSP', value: '36540' },
  { label: 'JUSPAY MASTER ALTID TSP', value: '36520' },
  { label: 'Bajaj Pay', value: '23060' },
  { label: 'AIRTEL PAYMENT BANK UPI', value: '13820' },
  { label: 'PhonePe', value: '9690' },
  { label: 'MobiKwik Wallet', value: '1990' },
];
export const NET_BANKING_OPTIONS_LIVE = [
  { label: 'Bank of India', value: '240' },
  { label: 'Indian Bank', value: '490' },
  { label: 'Tamilnad Mercantile Bank', value: '620' },
  { label: 'Central Bank of India', value: '740' },
  { label: 'Bank of Maharashtra', value: '750' },
  { label: 'Karur Vysya Bank', value: '760' },
  { label: 'Canara Bank', value: '930' },
  { label: 'Punjab National Bank', value: '1220' },
  { label: 'RBL Bank Limited', value: '1500' },
  { label: 'SVC Cooperative Bank Ltd', value: '1700' },
  { label: 'Uco Bank', value: '2030' },
  { label: 'Punjab and Sind Bank', value: '2390' },
  { label: 'Standard Chartered Bank', value: '450' },
  { label: 'Indian Overseas NetBanking', value: '420' },
  { label: 'Dhanlaxmi Bank', value: '370' },
  { label: 'Jammu and Kashmir Bank', value: '350' },
  { label: 'Bank of Baroda Retail', value: '310' },
  { label: 'Union Bank of India', value: '190' },
  { label: 'South Indian Bank', value: '180' },
  { label: 'Karnataka Bank', value: '140' },
  { label: 'JUSPAY VISA ALTID TSP', value: '36540' },
  { label: 'JUSPAY MASTER ALTID TSP', value: '36520' },
  { label: 'Bajaj Pay', value: '23060' },
  { label: 'AIRTEL PAYMENT BANK UPI', value: '13820' },
  { label: 'PhonePe', value: '9690' },
  { label: 'MobiKwik Wallet', value: '1990' },
];
export const PAYU_BANKING_OPTIONS = [
  { label: 'ICICI Bank', value: 'ICIB' },
  { label: 'Standard Chartered Bank', value: 'SCBNB' },
  { label: 'State Bank of India', value: 'SBIB' },
  { label: 'Kotak Bank', value: '162B' },
  { label: 'HDFC Bank', value: 'HDFB' },
  { label: 'AXIS Bank', value: 'AXIB' },
  { label: 'Federal Bank', value: 'FEDB' },
  { label: 'Jammu and Kashmir', value: 'JAKB' },
  { label: 'Yes Bank', value: 'YESB' },
  { label: 'HDFC Corporate Netbanking', value: 'HDFCCONB' },
  { label: 'ICICI Corporate Banking', value: 'ICICICNB' },
  { label: 'SBI Corporate Banking', value: 'SBNCORP' },
  { label: 'Kotak Corporate Banking', value: 'KTKBCORP' },
  { label: 'Axis Corporate Banking', value: 'AXISCNB' },
  { label: 'Federal Corporate Banking', value: 'FEDCORP' },
];
export const PAYU_BANKING_OPTIONS_LIVE = [
  { label: 'ICICI Bank', value: 'ICIB' },
  { label: 'Standard Chartered Bank', value: 'SCBNB' },
  { label: 'State Bank of India', value: 'SBIB' },
  { label: 'HDFC Bank', value: 'HDFB' },
  { label: 'AXIS Bank', value: 'AXIB' },
  { label: 'Federal Bank', value: 'FEDB' },
  { label: 'Jammu and Kashmir', value: 'JAKB' },
  { label: 'Yes Bank', value: 'YESB' },
  { label: 'HDFC Corporate Netbanking', value: 'HDFCCONB' },
  { label: 'ICICI Corporate Banking', value: 'ICICICNB' },
  { label: 'SBI Corporate Banking', value: 'SBNCORP' },
  { label: 'Kotak Corporate Banking', value: 'KTKBCORP' },
  { label: 'Axis Corporate Banking', value: 'AXISCNB' },
  { label: 'Federal Corporate Banking', value: 'FEDCORP' },
];
